import {
  GLOBAL_QUOTATION_CREATE_REQUEST,
  GLOBAL_QUOTATION_CREATE_SUCCESS,
  GLOBAL_QUOTATION_CREATE_ERROR,

  GLOBAL_QUOTATION_UPDATE_REQUEST,
  GLOBAL_QUOTATION_UPDATE_SUCCESS,
  GLOBAL_QUOTATION_UPDATE_ERROR,

  GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_REQUEST,
  GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_SUCCESS,
  GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_ERROR,

  // GLOBAL_QUOTATION_SET_STEP,
  GLOBAL_QUOTATION_RESET_STATE_QUOTATION,

  GLOBAL_QUOTATION_STORE_PACKAGE,
  GLOBAL_QUOTATION_STORE_COVERAGES,
  GLOBAL_QUOTATION_STORE_ASSISTS,
  GLOBAL_QUOTATION_REMOVE_PACKAGES_BY_INSURANCE_CARRIERS,
  GLOBAL_QUOTATION_ADD_INACTIVE_PACKAGES,
  GLOBAL_QUOTATION_SET_DATA,
} from 'Redux/types/globalQuotationTypes';

import { combineReducers } from 'redux';
import vehicle from 'Redux/reducers/globalQuotation/vehicleReducer';
import taker from 'Redux/reducers/globalQuotation/takerReducer';
import globals from 'Redux/reducers/globalQuotation/globalsReducer';

const initianState = {
  id: null,
  state: null,

  coverages: [],
  assists: [],
  packages: [],
  inactivePackages: [],

  isBeneficiarySameAsTaker: true,
  beneficiary: {},

  requestState: {
    isFeching: false,
    message: '',
    statusCode: null,
  },
};

// // PENDIENTE ELIMINAR!!! - Se hizo para el desarrollo de las comparaciones
// let fakeInitialState = {
//   ...initianState,

//   id: 1,
//   state: 'DONE',
// };

const quotation = (state = initianState, actions) => {
  switch (actions.type) {
    // ------------------------- ------------------------- ------------------------- ------------------------- -------------------------
    case GLOBAL_QUOTATION_CREATE_REQUEST: {
      return {
        ...state,
        requestState: {
          isFeching: true,
        },
      };
    }
    case GLOBAL_QUOTATION_CREATE_SUCCESS: {
      return {
        ...state,
        id: actions.response.data.id,
        state: actions.response.data.state,
        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      };
    }
    case GLOBAL_QUOTATION_CREATE_ERROR: {
      return {
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      };
    }
    
    // ------------------------- ------------------------- ------------------------- ------------------------- -------------------------
    // Update Quotation
    case GLOBAL_QUOTATION_UPDATE_REQUEST: {
      return {
        ...state,
        requestState: {
          isFeching: true,
        },
      };
    }
    case GLOBAL_QUOTATION_UPDATE_SUCCESS: {
      return {
        ...state,
        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      };
    }
    case GLOBAL_QUOTATION_UPDATE_ERROR: {
      return {
        ...state,
        requestState: {
          isFeching: false,
          message: actions?.response?.data?.message || 'Error al actualizar la cotización',
          statusCode: actions?.response?.status || 500,
        },
      };
    }

    // ------------------------- ------------------------- ------------------------- ------------------------- -------------------------
    case GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_REQUEST: {
      return {
        ...state,
        requestState: {
          isFeching: true,
        },
      };
    }

    case GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_SUCCESS: {
      return {
        ...state,
        // coverages: actions.response.data.coverages,
        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      };
    }

    case GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_ERROR: {
      return {
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.message,
          statusCode: actions.response.status,
        },
      };
    }

    case GLOBAL_QUOTATION_RESET_STATE_QUOTATION: {
      return {
        ...state,
        ...initianState,
        ...actions.defaults,

      };
    }

    case GLOBAL_QUOTATION_STORE_PACKAGE: {
      // Por si se vuelve a publicar el ID de un paquete, NO se duplique, sino que se sobreescriba :)
      const packagesWithoutThis = state.packages.filter((item) => item.id !== actions.package.id);
      packagesWithoutThis.push(actions.package);
      return {
        ...state,
        packages: packagesWithoutThis,
      };
    }

    case GLOBAL_QUOTATION_REMOVE_PACKAGES_BY_INSURANCE_CARRIERS: {
      // Se eliminan los paquetes de las aseguradoras indicadas
      const finalPackages = state.packages.filter(
        ({ insurance_carrier: insuranceCarrierId }) => !actions.insuranceCarrierIds.includes(insuranceCarrierId)
      );

      return {
        ...state,
        packages: finalPackages,
      };
    }

    case GLOBAL_QUOTATION_STORE_COVERAGES: {
      return {
        ...state,
        coverages: actions.coverages,
      };
    }

    case GLOBAL_QUOTATION_STORE_ASSISTS: {
      return {
        ...state,
        assists: actions.assists,
      };
    }

    case GLOBAL_QUOTATION_ADD_INACTIVE_PACKAGES: {
      return {
        ...state,
        inactivePackages: [...state.inactivePackages, ...actions.payload],
      };
    }

    case GLOBAL_QUOTATION_SET_DATA: { // Permite actualizar cualquier campo de la cotización
      return {
        ...state,
        ...actions.payload,
      };
    }

    default:
      return state;
  }
};

const rootGlobalQuotation = combineReducers({
  vehicle,
  taker,
  quotation,
  globals, // Es donde se controlan las configuraciones como el Step y cosas así
});

export default rootGlobalQuotation;
